import { PureComponent } from 'preact-compat'

import { IdeaStatus } from '../interfaces'

export interface TopicPillsProps {
  trashed: boolean
  spam: boolean
  pending: boolean
  sticky?: boolean
  publicLabel?: string | null
  ideationStatus?: IdeaStatus
  author?: boolean
  hasBestAnswer?: boolean
}

class TopicPills extends PureComponent<TopicPillsProps> {
  render() {
    const { trashed, spam, ideationStatus, publicLabel, pending, author, sticky, hasBestAnswer } = this.props
    return (
      <div className='pill-container'>
        {trashed && <span className='pill pill--trashed'>trashed</span>}
        {pending && <span className='pill pill--pending'>pending</span>}
        {ideationStatus && (
          <span
            className='idea-status-pill'
            style={{
              color: `#${ideationStatus.textColor}`,
              backgroundColor: `#${ideationStatus.backgroundColor}`
            }}
          >
            {ideationStatus.name}
          </span>
        )}
        {sticky && <span className='pill pill--sticky'>sticky</span>}
        {publicLabel && <span className='pill pill-article-label'>{publicLabel}</span>}
        {spam && <span className='pill pill--spam'>spam</span>}
        {author && <span className='pill pill--author'>author</span>}
        {hasBestAnswer && <span className='pill pill--solved'>solved</span>}
      </div>
    )
  }
}

export default TopicPills
